import { forwardRef, type CSSProperties, type ReactNode } from "react"
import { cn } from "@strivelabs/ui-core"
import { useStickAtRest } from "./use-stick-at-rest"

interface StickAtRestProps {
  /** Pin the block to the page's scroller where it rests. Off, it is an ordinary block. */
  sticky: boolean
  className?: string
  style?: CSSProperties
  children: ReactNode
}

/**
 * A block that, when `sticky`, is pinned exactly where it already rests — the
 * marker `useStickAtRest` measures from, placed right before it, and the
 * resulting `top`. One component so the marker can never be left out or put on
 * the wrong side of the block it measures for.
 */
export const StickAtRest = forwardRef<HTMLDivElement, StickAtRestProps>(
  function StickAtRest ({ sticky, className, style, children }, ref) {
    const { markerRef, top } = useStickAtRest(sticky)
    return (
      <>
        <span ref={markerRef} aria-hidden className="block h-0" />
        {/* `sticky` last, so it wins over a caller's `relative` (both are
            position utilities, and the merge keeps the later one). */}
        <div ref={ref} className={cn(className, sticky && "sticky")} style={{ ...style, top }}>
          {children}
        </div>
      </>
    )
  },
)
